import React from 'react';
import { useNavigate } from 'react-router-dom';

const DOS_FONT = "'VT323', 'Courier New', monospace";
const raisedShadow = 'inset -1px -1px 0 #808080, inset 1px 1px 0 #ffffff';
const deepRaisedShadow = 'inset -2px -2px 0 #404040, inset 2px 2px 0 #ffffff, inset -1px -1px 0 #808080, inset 1px 1px 0 #dfdfdf';

const DOSServiceCard = ({ service }) => {
    const navigate = useNavigate();

    return (
        <div
            onClick={() => navigate(service.link)}
            className="cursor-pointer flex flex-col h-full select-none hover:brightness-75 transition-all duration-150"
            style={{
                backgroundColor: '#c0c0c0',
                boxShadow: deepRaisedShadow,
                fontFamily: DOS_FONT,
            }}
        >
            {/* ── Title bar ── */}
            <div
                className="flex items-center justify-between px-[6px] py-[3px] shrink-0"
                style={{ backgroundColor: '#000080' }}
            >
                <div className="flex items-center gap-[6px] overflow-hidden">
                    <span className="text-white text-[13px] opacity-80 shrink-0">
                        {service.icon}
                    </span>
                    <span
                        className="text-white text-[15px] truncate font-bold tracking-wide"
                        style={{ fontFamily: DOS_FONT }}
                    >
                        {service.title.toUpperCase()}
                    </span>
                </div>
                {/* Window buttons */}
                <div className="flex gap-[2px] shrink-0 ml-2">
                    {['▂', '▣', '✕'].map((btn, i) => (
                        <span
                            key={i}
                            className="w-[16px] h-[16px] text-black flex items-center justify-center font-bold"
                            style={{
                                backgroundColor: '#c0c0c0',
                                boxShadow: raisedShadow,
                                lineHeight: 1,
                                fontSize: '9px',
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {btn}
                        </span>
                    ))}
                </div>
            </div>

            {/* ── Body: description ── */}
            <div className="flex flex-col flex-1 px-3 py-3">
                <p
                    className="text-black leading-tight"
                    style={{ fontFamily: DOS_FONT, fontSize: '18px' }}
                >
                    {service.description}
                </p>
            </div>
        </div>
    );
};

export default DOSServiceCard;
